import { render, staticRenderFns } from "./TopToolBar.vue?vue&type=template&id=6078dec4"
import script from "./TopToolBar.vue?vue&type=script&lang=js"
export * from "./TopToolBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports